<template>
    <div class="widget-calendar">
        <dashboardCard heading='Acquire Usage' :data1="acquireCount" :data2="acquireMax" :data3="acquireTime">
        </dashboardCard>
    </div>
</template>
<script>
import dashboardCard from "./DashboardCard.vue";
export default {
    name: "aqcuireDetail",
    components: {
        dashboardCard
    },
    data() {
        return {
            acquireCount: {},
            acquireMax: {},
            acquireTime: {},
        };
    },
    methods: {
        getHikariAquireInfo(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.acquireCount.value = this.formatValue(JSON.parse(response.server.data[0].value).toFixed(3));
                    this.acquireCount.name = 'Count';
                    this.acquireTime.value = this.formatTime(JSON.parse(response.server.data[1].value).toFixed(2));
                    this.acquireTime.name = 'Total Time'
                    this.acquireMax.value = this.formatTime(JSON.parse(response.server.data[2].value).toFixed(2));
                    this.acquireMax.name = 'Max';
                    this.acquireCount.description = 'Total connection requests.';
                    this.acquireMax.description = 'The maximum time it took to acquire a connection.';
                    this.acquireTime.description = 'The total time spent acquiring connections.';
                })
                .catch(error => {
                    console.log(error);
                });
        },
        formatValue(value) {
            return value > 100 ? (value / 1000).toFixed(2) + 'k' : value;
        },
        formatTime(seconds) {
            if (seconds < 60) {
                return `${seconds}s`;
            } else if (seconds < 3600) {
                const minutes = Math.floor(seconds / 60);
                return `${minutes}m`;
            } else {
                const hours = Math.floor(seconds / 3600);
                const minutes = Math.floor((seconds % 3600) / 60);
                const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
                return `${hours}h ${formattedMinutes}m`;
            }
        },
    },
    mounted() {
        this.getHikariAquireInfo("HIKARICP_CONNECTIONS_ACQUIRE");
    }
};
</script>